<script>
import { booleProps, initValue } from '../index'

export default {
  props: booleProps,
  render () {
    const value = initValue(this.value, { options: this.options, uiComponent: this.uiComponent })
    return <read-text props={{...this.$props, value}}></read-text>
  }
}
</script>